import { useEffect, useRef } from "react";

/**
 * Gráfico avanzado de TradingView (widget oficial gratuito).
 * Velas, indicadores, multitimeframe y cambio de símbolo integrado.
 * Se carga en el navegador del usuario: no pasa por nuestro servidor.
 */
function TradingViewChart({ symbol = "BINANCE:BTCUSDT", interval = "60" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Estructura que espera el script del widget
    container.innerHTML = '<div class="tradingview-widget-container__widget" style="height:100%;width:100%"></div>';

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol,
      interval,
      timezone: "Europe/Madrid",
      theme: "dark",
      style: "1", // velas japonesas
      locale: "es",
      backgroundColor: "rgba(10, 10, 11, 1)",
      gridColor: "rgba(55, 65, 81, 0.3)",
      allow_symbol_change: true,
      withdateranges: true,
      hide_side_toolbar: false,
      studies: ["Volume@tv-basicstudies"],
      support_host: "https://www.tradingview.com",
    });
    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [symbol, interval]);

  return (
    <div
      ref={containerRef}
      className="tradingview-widget-container"
      style={{ height: "100%", width: "100%" }}
      data-testid="tradingview-chart"
    />
  );
}

export default TradingViewChart;
